import {SalaryDividendOptions} from '../../../options/calculations/salary-dividend/salary-dividend.options';
import {TypeUtil} from '../../../utils/type.util';
import {CalculationKeynameEnum} from '../../../enums/calculations/calculation-keyname.enum';
import {MoneyUtil} from '../../../utils/money.util';

import {v4 as uuid} from 'uuid';
import {
    IncomeTaxPersonalChildCampOptions,
} from '../../../options/calculations/income-tax/personal/common/income-tax-personal-child-camp.options';
import {
    SalaryContributionsOptionsInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/salary-contributions/salary-contributions-options-in-salary-dividend.options';
import {CompanyTypeEnum} from '../../../enums/company-type.enum';
import {CalculationDate} from '../../../models/calculation.date';
import {
    QppPensionOptionsInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/qpp-pension/qpp-pension-options-in-salary-dividend.options';
import {
    CorporateIncomeTaxConnectedCorporationOptions,
} from '../../../options/calculations/income-tax/corporate/common/corporate-income-tax-connected-corporation.options';
import {
    CorporateIncomeTaxInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/income-tax/corporate/corporate-income-tax-in-salary-dividend.options';
import {
    CorporateIncomeTaxFederalInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/income-tax/corporate/corporate-income-tax-federal-in-salary-dividend.options';
import {
    CorporateIncomeTaxQuebecInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/income-tax/corporate/corporate-income-tax-quebec-in-salary-dividend.options';
import {
    IncomeTaxPersonalInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/income-tax/personal/income-tax-personal-in-salary-dividend.options';
import {
    IncomeTaxPersonalSpouseInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/income-tax/personal/income-tax-personal-spouse-in-salary-dividend.options';
import {
    IncomeTaxPersonalSpouseFederalInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/income-tax/personal/income-tax-personal-spouse-federal-in-salary-dividend.options';
import {
    IncomeTaxPersonalChildFederalInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/income-tax/personal/income-tax-personal-child-federal-in-salary-dividend.options';
import {
    IncomeTaxPersonalChildInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/income-tax/personal/income-tax-personal-child-in-salary-dividend.options';
import {
    IncomeTaxPersonalChildQuebecInSalaryDividendOptions,
} from '../../../options/calculations/salary-dividend/income-tax/personal/income-tax-personal-child-quebec-in-salary-dividend.options';

// todo: check this
const fiscalYear = 2023;

export const salaryVsDividendsScenario1Options: SalaryDividendOptions = TypeUtil.create(SalaryDividendOptions, {
  calculationKeyname: CalculationKeynameEnum.SalaryDividendSimulation,
  year: fiscalYear,
  isEligibleDividendMaximized: false,
  isQppPensionCalculated: true,
  costOfLiving: MoneyUtil.dollarsToCent('60 000'),
  isShareHolderSubjectToEI: false,
  qppPensionOptions: TypeUtil.create(QppPensionOptionsInSalaryDividendOptions, {
    deathAge: 70,
    qPPIncreasingRate: 1.5,
    investmentRate: 5,

  }),
  incomeTaxPersonalOptions: TypeUtil.create(IncomeTaxPersonalInSalaryDividendOptions, {
    isMarried: true,
    isCareExpensesCalculated: true,
    mainPerson: TypeUtil.create(IncomeTaxPersonalSpouseInSalaryDividendOptions, {
      id: uuid(),
      firstName: 'Jean',
      lastName: 'Tremblay',
      birthdate: new CalculationDate({ year: 1983, month: 8, day: 5 }), // 1990-08-05
      employmentIncome: MoneyUtil.dollarsToCent('15 000'),
      realEligibleDividend: MoneyUtil.dollarsToCent('3 000'),
      realNonEligibleDividend: MoneyUtil.dollarsToCent('2 000'),
      gainPubliclyTradeShares: MoneyUtil.dollarsToCent('5 000'),
      othersIncomesLine13000: MoneyUtil.dollarsToCent('500'),
      isEligibleToCWB: true,
      isEmployeeSubjectToEI: true,
      federal: TypeUtil.create(IncomeTaxPersonalSpouseFederalInSalaryDividendOptions, {
        maximumAllowedDeductibleContributionsRRSP: MoneyUtil.dollarsToCent('4 000'),
        paidContributionRRSP: MoneyUtil.dollarsToCent('3 000'),
      }),

    }),
    spouse: TypeUtil.create(IncomeTaxPersonalSpouseInSalaryDividendOptions, {
      id: uuid(),
      firstName: 'Jeanne',
      lastName: 'Tremblay',
      birthdate: new CalculationDate({ year: 1995, month: 9, day: 1 }), // 1995-09-01
      employmentIncome: MoneyUtil.dollarsToCent('50 000'),
      realEligibleDividend: MoneyUtil.dollarsToCent('555'),
      realNonEligibleDividend: MoneyUtil.dollarsToCent('666'),
      gainPubliclyTradeShares: MoneyUtil.dollarsToCent('3 000'),
      othersIncomesLine13000: MoneyUtil.dollarsToCent('222'),
      isEligibleToCWB: true,
      isEmployeeSubjectToEI: true,
      federal: TypeUtil.create(IncomeTaxPersonalSpouseFederalInSalaryDividendOptions, {
        maximumAllowedDeductibleContributionsRRSP: MoneyUtil.dollarsToCent('10 000'),
        paidContributionRRSP: MoneyUtil.dollarsToCent('5 000'),
      }),
    }),
    children: [
      // Child 1
      TypeUtil.create(IncomeTaxPersonalChildInSalaryDividendOptions, {
        id: uuid(),
        firstName: 'Jeannette',
        lastName: 'Tremblay',

        birthdate: new CalculationDate({ year: 2019, month: 1, day: 6 }), // 2019-01-06
        isDisabled: false,
        netIncome: 0,
        federal: TypeUtil.create(IncomeTaxPersonalChildFederalInSalaryDividendOptions, {
          careExpensesOthers: MoneyUtil.dollarsToCent('5 000'),
        }),
        quebec: TypeUtil.create(IncomeTaxPersonalChildQuebecInSalaryDividendOptions, {
          careExpensesOthers: MoneyUtil.dollarsToCent('3 000'),
        }),
        camps: [
          TypeUtil.create(IncomeTaxPersonalChildCampOptions, {
            id: uuid(),
            numberOfWeeks: 4,
            careExpenses: MoneyUtil.dollarsToCent('2 000'),
          }),
          TypeUtil.create(IncomeTaxPersonalChildCampOptions, {
            id: uuid(),
            numberOfWeeks: 2,
            careExpenses: MoneyUtil.dollarsToCent('30'),
          }),
          TypeUtil.create(IncomeTaxPersonalChildCampOptions, {
            id: uuid(),
            numberOfWeeks: 6,
            careExpenses: MoneyUtil.dollarsToCent('300'),
          }),
        ],

      }),
      // Child 2
      TypeUtil.create(IncomeTaxPersonalChildInSalaryDividendOptions, {
        id: uuid(),
        firstName: 'Jeanine',
        lastName: 'Tremblay',
        birthdate: new CalculationDate({ year: 2009, month: 7, day: 9 }), // 2009-07-09
        isDisabled: false,
        netIncome: MoneyUtil.dollarsToCent('5 000'),
        federal: TypeUtil.create(IncomeTaxPersonalChildFederalInSalaryDividendOptions, {
          careExpensesOthers: MoneyUtil.dollarsToCent('10 000'),
        }),
        quebec: TypeUtil.create(IncomeTaxPersonalChildQuebecInSalaryDividendOptions, {
          careExpensesOthers: MoneyUtil.dollarsToCent('9 000'),
        }),
        camps: [
          TypeUtil.create(IncomeTaxPersonalChildCampOptions, {
            id: uuid(),
            numberOfWeeks: 1,
            careExpenses: MoneyUtil.dollarsToCent('8 000'),
          }),
          TypeUtil.create(IncomeTaxPersonalChildCampOptions, {
            id: uuid(),
            numberOfWeeks: 2,
            careExpenses: MoneyUtil.dollarsToCent('4 000'),
          }),
        ],

      }),
      // Child 3
      TypeUtil.create(IncomeTaxPersonalChildInSalaryDividendOptions, {
        id: uuid(),
        firstName: 'Johanne',
        lastName: 'Tremblay',
        birthdate: new CalculationDate({ year: 1996, month: 5, day: 23 }), // 1996-05-23
        isDisabled: true,
        netIncome: MoneyUtil.dollarsToCent('1 000'),
        federal: TypeUtil.create(IncomeTaxPersonalChildFederalInSalaryDividendOptions, {
          careExpensesOthers: MoneyUtil.dollarsToCent('20 000'),
        }),
        quebec: TypeUtil.create(IncomeTaxPersonalChildQuebecInSalaryDividendOptions, {
          careExpensesOthers: MoneyUtil.dollarsToCent('16 000'),
        }),
        camps: [
          TypeUtil.create(IncomeTaxPersonalChildCampOptions, {
            id: uuid(),
            numberOfWeeks: 2,
            careExpenses: MoneyUtil.dollarsToCent('3 000'),
          }),
          TypeUtil.create(IncomeTaxPersonalChildCampOptions, {
            id: uuid(),
            numberOfWeeks: 3,
            careExpenses: MoneyUtil.dollarsToCent('6 000'),
          }),
        ],

      }),
    ],
  }),
  salaryContributionsOptions: TypeUtil.create(SalaryContributionsOptionsInSalaryDividendOptions, {
    totalPayroll: MoneyUtil.dollarsToCent('400 000'),
    totalPayrollForPrimarySector: 0,
    isEmployerFromPublicSector: false,
    recurringPaymentRate: 6,
    shouldFSSBeCalculated: true,
    shouldCNTBeCalculated: true,
    shouldCNESSTBeCalculated: true,
  }),
  corporateIncomeTaxOptions: TypeUtil.create(CorporateIncomeTaxInSalaryDividendOptions, {
    fiscalYearStart: new CalculationDate({ year: 2023, month: 1, day: 1 }), // 2023-01-01
    fiscalYearEnd: new CalculationDate({ year: 2023, month: 12, day: 31 }), // 2023-12-31
    companyType: CompanyTypeEnum.ccpcAllYear,
    lossTaxRate: 50,
    totalTaxableCapital: MoneyUtil.dollarsToCent('30 000'),
    businessIncome: MoneyUtil.dollarsToCent('300 000'),
    adjustedInvestmentIncome: MoneyUtil.dollarsToCent('50 000'),
    capitalLossBalance: MoneyUtil.dollarsToCent('5 000'),
    nonCapitalLossBalance: MoneyUtil.dollarsToCent('10 000'),
    assignedBusinessLimit: MoneyUtil.dollarsToCent('250 000'),
    interestIncome: MoneyUtil.dollarsToCent('5 000'),
    incomeTaxCorporationQuebec: TypeUtil.create(CorporateIncomeTaxQuebecInSalaryDividendOptions, {
      currentPaidHours: 60000,
      previousPaidHours: 0,
      isManufacturingSectorActivity: false,
    }),
    incomeTaxCorporationFederal: TypeUtil.create(CorporateIncomeTaxFederalInSalaryDividendOptions, {
      nonEligibleDividendNonConnected: MoneyUtil.dollarsToCent('3 000'),
      eligibleDividendNonConnected: MoneyUtil.dollarsToCent('4 000'),
      capitalGain: MoneyUtil.dollarsToCent('3 000'),
      capitalLoss: 0,
      previousIMRTDND: MoneyUtil.dollarsToCent('5 000'),
      previousRTDND: MoneyUtil.dollarsToCent('4 800'),
      nonEligibleDividendPaid: MoneyUtil.dollarsToCent('2 000'),
      previousIMRTDD: MoneyUtil.dollarsToCent('3 000'),
      previousRTDD: MoneyUtil.dollarsToCent('2 000'),
      eligibleDividendPaidLastYear: MoneyUtil.dollarsToCent('3 000'),
      gRIPBalance: MoneyUtil.dollarsToCent('6 000'),
      eligibleDividendPaid: MoneyUtil.dollarsToCent('1 000'),
      lRIPBalance: 0,
      isPartIVTaxUsed: true,
    }),
    connectedCorporations: [
      // Corporation 1
      TypeUtil.create(CorporateIncomeTaxConnectedCorporationOptions, {
        title: 'Compagnie 1',
        id: uuid(),
        dividendRefundNonEligible: MoneyUtil.dollarsToCent('1 000'),
        dividendRefundEligible: MoneyUtil.dollarsToCent('500'),
        nonEligibleDividendReceived: MoneyUtil.dollarsToCent('6 000'),
        eligibleDividendReceived: MoneyUtil.dollarsToCent('7 000'),
        totalDividendPaid: MoneyUtil.dollarsToCent('20 000'),
      }),

      // Corporate 2
      TypeUtil.create(CorporateIncomeTaxConnectedCorporationOptions, {
        title: 'Compagnie 2',
        id: uuid(),
        dividendRefundNonEligible: MoneyUtil.dollarsToCent('1 000'),
        dividendRefundEligible: MoneyUtil.dollarsToCent('0'),
        nonEligibleDividendReceived: MoneyUtil.dollarsToCent('4 000'),
        eligibleDividendReceived: MoneyUtil.dollarsToCent('0'),
        totalDividendPaid: MoneyUtil.dollarsToCent('4 000'),
      }),
    ],
  }),
});
